import { AppRouteProps } from '../../components/router/AppRoute';
import Activate from './index';

export const activateRoutes: AppRouteProps[] = [
  { path: 'activate', element: <Activate /> },
];
